
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as d2FzbTpqcy1zdHJpbmc from './BlackCatCarnival-fullWasmApp.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;
let require;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    const module = await import(/* webpackIgnore: true */'node:module');
    const importMeta = import.meta;
    require = module.default.createRequire(importMeta.url);
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.doubleToExternref' : (x) => x,
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.io.printError' : (error) => console.error(error),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.JsArray_$external_class_instanceof' : (x) => x instanceof Array,
    'kotlin.js.JsArray_$external_class_get' : () => Array,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsNumber_$external_class_instanceof' : (x) => typeof x === 'number',
    'kotlin.js.JsNumber_$external_class_get' : () => JsNumber,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
    'kotlin.uuid.get' : (array, index) => array[index],
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'kotlinx.coroutines.internal.throwAsyncJsError' : (message, className, stack) => { 
            var error = new Error();
            error.message = message;
            error.name = className;
            error.stack = stack;
            if (typeof globalThis.reportError === 'function') {
                // Up-to-date browsers and some non-browser JS runtimes (Deno, Bun)
                globalThis.reportError(error);
            } else {
                // Fallback for old browsers (pre-2022), Node.js
                setTimeout(function () { throw error }, 0);
            }
         },
    'org.khronos.webgl.setMethodImplForInt16Array' : (obj, index, value) => { obj[index] = value; },
    'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.setMethodImplForInt8Array' : (obj, index, value) => { obj[index] = value; },
    'org.khronos.webgl.getMethodImplForInt16Array' : (obj, index) => obj[index],
    'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.Int16Array_$external_fun' : (p0) => new Int16Array(p0),
    'org.khronos.webgl.Int8Array_$external_fun' : (p0) => new Int8Array(p0),
    'org.khronos.webgl.Int8Array_$external_fun_1' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.khronos.webgl.set_$external_fun' : (_this, p0, p1, isDefault0) => _this.set(p0, isDefault0 ? undefined : p1, ),
    'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter_1' : (_this) => _this.buffer,
    'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.byteLength_$external_prop_getter_1' : (_this) => _this.byteLength,
    'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
    'org.khronos.webgl.ArrayBuffer_$external_class_instanceof' : (x) => x instanceof ArrayBuffer,
    'org.khronos.webgl.ArrayBuffer_$external_class_get' : () => ArrayBuffer,
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.target_$external_prop_getter' : (_this) => _this.target,
    'org.w3c.dom.events.cancelable_$external_prop_getter' : (_this) => _this.cancelable,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.Event_$external_class_get' : () => Event,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.repeat_$external_prop_getter' : (_this) => _this.repeat,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.FocusEvent_$external_class_instanceof' : (x) => x instanceof FocusEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_get' : () => FocusEvent,
    'org.w3c.dom.events.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.events.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.isComposing_$external_prop_getter_1' : (_this) => _this.isComposing,
    'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.EventSourceInit_js_code' : (withCredentials) => ({ withCredentials: withCredentials }),
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.Worker_$external_fun' : (p0, p1, isDefault0) => new Worker(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.onmessage_$external_prop_setter' : (_this, v) => _this.onmessage = v,
    'org.w3c.dom.onerror_$external_prop_setter' : (_this, v) => _this.onerror = v,
    'org.w3c.dom.postMessage_$external_fun' : (_this, p0, p1, isDefault0) => _this.postMessage(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.Worker_$external_class_instanceof' : (x) => x instanceof Worker,
    'org.w3c.dom.Worker_$external_class_get' : () => Worker,
    'org.w3c.dom.EventSource_$external_fun' : (p0, p1, isDefault0) => new EventSource(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.onmessage_$external_prop_setter_1' : (_this, v) => _this.onmessage = v,
    'org.w3c.dom.onerror_$external_prop_setter_1' : (_this, v) => _this.onerror = v,
    'org.w3c.dom.close_$external_fun' : (_this, ) => _this.close(),
    'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.MessageEvent_$external_class_instanceof' : (x) => x instanceof MessageEvent,
    'org.w3c.dom.MessageEvent_$external_class_get' : () => MessageEvent,
    'org.w3c.dom.message_$external_prop_getter' : (_this) => _this.message,
    'org.w3c.dom.ErrorEvent_$external_class_instanceof' : (x) => x instanceof ErrorEvent,
    'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
    'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.shadowRoot_$external_prop_getter' : (_this) => _this.shadowRoot,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
    'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.history_$external_prop_getter' : (_this) => _this.history,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.href_$external_prop_getter' : (_this) => _this.href,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.pathname_$external_prop_getter' : (_this) => _this.pathname,
    'org.w3c.dom.search_$external_prop_getter' : (_this) => _this.search,
    'org.w3c.dom.hash_$external_prop_getter' : (_this) => _this.hash,
    'org.w3c.dom.assign_$external_fun' : (_this, p0) => _this.assign(p0),
    'org.w3c.dom.reload_$external_fun' : (_this, ) => _this.reload(),
    'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
    'org.w3c.dom.firstChild_$external_prop_getter' : (_this) => _this.firstChild,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.hasChildNodes_$external_fun' : (_this, ) => _this.hasChildNodes(),
    'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.readyState_$external_prop_getter_1' : (_this) => _this.readyState,
    'org.w3c.dom.bufferedAmount_$external_prop_getter' : (_this) => _this.bufferedAmount,
    'org.w3c.dom.onopen_$external_prop_setter' : (_this, v) => _this.onopen = v,
    'org.w3c.dom.onerror_$external_prop_setter_2' : (_this, v) => _this.onerror = v,
    'org.w3c.dom.onclose_$external_prop_setter' : (_this, v) => _this.onclose = v,
    'org.w3c.dom.protocol_$external_prop_getter_1' : (_this) => _this.protocol,
    'org.w3c.dom.onmessage_$external_prop_setter_2' : (_this, v) => _this.onmessage = v,
    'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
    'org.w3c.dom.close_$external_fun_1' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.OPEN_$external_prop_getter' : (_this) => _this.OPEN,
    'org.w3c.dom.Companion_$external_object_getInstance' : () => WebSocket,
    'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.replaceState_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.replaceState(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.Companion_$external_object_getInstance_2' : () => ({}),
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
    'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
    'org.w3c.dom.pointerevents.pointerId_$external_prop_getter' : (_this) => _this.pointerId,
    'org.w3c.dom.pointerevents.pressure_$external_prop_getter' : (_this) => _this.pressure,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_instanceof' : (x) => x instanceof PointerEvent,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_get' : () => PointerEvent,
    'org.w3c.dom.url.createObjectURL_$external_fun' : (_this, p0) => _this.createObjectURL(p0),
    'org.w3c.dom.url.revokeObjectURL_$external_fun' : (_this, p0) => _this.revokeObjectURL(p0),
    'org.w3c.dom.url.Companion_$external_object_getInstance' : () => URL,
    'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
    'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
    'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.fetch.Response_$external_class_instanceof' : (x) => x instanceof Response,
    'org.w3c.fetch.Response_$external_class_get' : () => Response,
    'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'org.w3c.xhr.XMLHttpRequest_$external_fun' : () => new XMLHttpRequest(),
    'org.w3c.xhr.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.xhr.open_$external_fun' : (_this, p0, p1, p2, p3, p4, isDefault0, isDefault1) => _this.open(p0, p1, p2, isDefault0 ? undefined : p3, isDefault1 ? undefined : p4, ),
    'org.w3c.xhr.send_$external_fun' : (_this, ) => _this.send(),
    'org.w3c.xhr.overrideMimeType_$external_fun' : (_this, p0) => _this.overrideMimeType(p0),
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1, p2) => _this.register(p0, p1, p2),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'androidx.lifecycle.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.lifecycle.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'androidx.compose.ui.text.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'androidx.compose.ui.text.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.withSignalAndPassive' : (signal, passive) => ({signal: signal, passive: passive}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.node.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.node.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
    'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
    'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
    'androidx.compose.ui.platform.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.platform.getRootNode_$external_fun' : (_this, ) => _this.getRootNode(),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.isMouseEvent' : (event) => event.pointerType === 'mouse',
    'androidx.compose.ui.window.setPointerCapture' : (target, pointerId) => { try { target.setPointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.getCoalescedEvents' : (pointerEvent) => pointerEvent.getCoalescedEvents ? pointerEvent.getCoalescedEvents() : [],
    'androidx.compose.ui.window.getPointerEventCode' : (event) => {
            switch (event.type) {
              case 'pointerdown':
                return 1; // PointerEventType.Press
              case 'pointerup':
              case 'pointercancel':
                return 2; // PointerEventType.Release
              case 'pointermove':
                return 3; // PointerEventType.Move
              case 'pointerenter':
                return 4; //PointerEventType.Enter
              case 'pointerleave':
                return 5; //PointerEventType.Exit
              default:
                return 0; // PointerEventType.Unknown
            } 
        },
    'androidx.compose.ui.window.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'androidx.compose.foundation.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.foundation.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.foundation.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.isInTestEnvironment' : () => window.composeResourcesTesting == true,
    'org.jetbrains.compose.resources.requestResponseAsByteArray' : (req) =>  {
            var text = req.responseText;
            var int8Arr = new Int8Array(text.length);
            for (var i = 0; i < text.length; i++) {
                int8Arr[i] = text.charCodeAt(i) & 0xFF;
            }
            return int8Arr;
        },
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.copyArrayBufferToWasmMemory' : (ab, ptr) => {
          const data = new Uint8Array(ab);
          new Uint8Array(wasmExports.memory.buffer).set(data, ptr);
    },
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
    'kotlinx.io.getPlatformName' : 
        () => (typeof navigator !== "undefined" && navigator.platform) || "unknown"
    ,
    'kotlinx.io.node.persistModule' : 
        (globalThis.module = (typeof process !== 'undefined') && (process.release.name === 'node') ?
            await import(/* webpackIgnore: true */'node:module') : void 0, () => {})
    ,
    'kotlinx.io.node.getRequire' : () => { 
        const importMeta = import.meta;
        return globalThis.module.default.createRequire(importMeta.url);
    }
    ,
    'kotlinx.io.node.requireModule' : 
        (require, mod) => {
             try {
                 let m = require(mod);
                 if (m) return m;
                 return null;
             } catch (e) {
                 return null;
             }
        }
    ,
    'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
    'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
    'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util.date.Date_$external_fun' : () => new Date(),
    'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
    'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
    'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
    'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
    'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
    'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
    'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
    'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
    'io.ktor.util._crypto_js_code' : () => ((globalThis ? globalThis.crypto : (window.crypto || window.msCrypto))),
    'io.ktor.util.getRandomValues_$external_fun' : (_this, p0) => _this.getRandomValues(p0),
    'io.ktor.util.hasNodeApi' : () => 
    (typeof process !== 'undefined' 
        && process.versions != null 
        && process.versions.node != null) ||
    (typeof window !== 'undefined' 
        && typeof window.process !== 'undefined' 
        && window.process.versions != null 
        && window.process.versions.node != null)
    ,
    'io.ktor.util.logging.getKtorLogLevel' : () => process ? process.env.KTOR_LOG_LEVEL : null,
    'io.ktor.util.logging.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
    'io.ktor.util.logging.console_$external_prop_getter' : () => console,
    'io.ktor.http.locationOrigin' : () => function() {
        var tmpLocation = null
        if (typeof window !== 'undefined') {
          tmpLocation = window.location
        } else if (typeof self !== 'undefined') {
          tmpLocation = self.location
        }
        var origin = ""
        if (tmpLocation) {
          origin = tmpLocation.origin
        }
        return origin && origin != "null" ? origin : "http://localhost"    
    }(),
    'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
    'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
    'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
    'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
    'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
    'io.ktor.client.fetch.credentials_$external_prop_setter' : (_this, v) => _this.credentials = v,
    'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
    'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
    'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
    'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
    'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
    'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
    'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
    'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
    'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
    'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
    'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
    'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
    'io.ktor.client.utils.makeJsObject' : () => { return {}; },
    'io.ktor.client.utils.makeImport' : (name) => import(name),
    'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
    'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
    'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
    'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
    'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
    'io.ktor.client.utils.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
    'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
    'com.apollographql.apollo.mpp.currentTimeMillis2' : () => (new Date()).getTime(),
    'com.apollographql.apollo.network.http.newAbortController' : () => new AbortController(),
    'com.apollographql.apollo.network.http.getKeys' : (headers) => Array.from(headers.keys()),
    'com.apollographql.apollo.network.http.makeJsObject' : () => { return {}; },
    'com.apollographql.apollo.network.http.setObjectField' : (obj, name, value) => obj[name]=value,
    'com.apollographql.apollo.network.http.toJsArrayImpl' : (x) => new Uint8Array(x),
    'com.apollographql.apollo.network.http.signal_$external_prop_getter' : (_this) => _this.signal,
    'com.apollographql.apollo.network.http.abort_$external_fun' : (_this, ) => _this.abort(),
    'com.apollographql.apollo.network.http.body_$external_prop_setter' : (_this, v) => _this.body = v,
    'com.apollographql.apollo.network.http.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
    'com.apollographql.apollo.network.http.method_$external_prop_setter' : (_this, v) => _this.method = v,
    'com.apollographql.apollo.network.http.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
    'com.apollographql.apollo.network.http.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
    'com.apollographql.apollo.network.http.getReader_$external_fun' : (_this, ) => _this.getReader(),
    'com.apollographql.apollo.network.http.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
    'com.apollographql.apollo.network.http.read_$external_fun' : (_this, ) => _this.read(),
    'com.apollographql.apollo.network.http.done_$external_prop_getter' : (_this) => _this.done,
    'com.apollographql.apollo.network.http.value_$external_prop_getter' : (_this) => _this.value,
    'com.apollographql.apollo.network.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
    'com.apollographql.apollo.network.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
    'com.apollographql.apollo.network.websocket.isEventClean' : (event) => event.wasClean,
    'com.apollographql.apollo.network.websocket.getCloseCode' : (event) => event.code || null,
    'com.apollographql.apollo.network.websocket.getCloseReason' : (event) => event.reason || null,
    'com.apollographql.apollo.network.websocket.isNodeEnvironment' : () => typeof process !== 'undefined' && process.versions != null && process.versions.node != null,
    'com.apollographql.apollo.network.websocket.createWebSocketSimple' : (url) => new WebSocket(url),
    'com.apollographql.apollo.network.websocket.createWebSocketWithProtocol' : (url, protocol) => new WebSocket(url, protocol),
    'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
    'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
    'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
    'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
    'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
    'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
    'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
        try {
            body();
            return null;
        } catch(e) {
            return e;
        }
    },
    'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
    'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
    'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
    'io.github.aakira.napier.log' : (message) => {
            console.log(message);
        },
    'io.github.aakira.napier.info' : (message) => {
            console.info(message);
        },
    'io.github.aakira.napier.warn' : (message) => {
            console.warn(message);
        },
    'io.github.aakira.napier.error' : (message) => {
            console.error(message);
        },
    'coil3.decode.blob' : (code) => new Blob([code], { type: 'application/javascript' }),
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.material3.internal.getFirstDayOfWeek' : (locale) => { try { 
               return new Intl.Locale(locale).weekInfo.firstDay; 
            } catch (error) { 
               return -1; 
          }},
    'androidx.compose.material3.internal.emptyLocaleOptions' : () => new Object(),
    'androidx.compose.material3.internal.Date_$external_fun' : (p0) => new Date(p0),
    'androidx.compose.material3.internal.Date_$external_fun_1' : (p0, p1, p2) => new Date(p0, p1, p2),
    'androidx.compose.material3.internal.getDay_$external_fun' : (_this, ) => _this.getDay(),
    'androidx.compose.material3.internal.toLocaleDateString_$external_fun' : (_this, p0, p1, isDefault0) => _this.toLocaleDateString(p0, isDefault0 ? undefined : p1, ),
    'androidx.compose.material3.internal.now_$external_fun' : (_this, ) => _this.now(),
    'androidx.compose.material3.internal.Companion_$external_object_getInstance' : () => Date,
    'androidx.compose.material3.internal.weekday_$external_prop_setter' : (_this, v) => _this.weekday = v,
    'androidx.compose.material3.internal.year_$external_prop_setter' : (_this, v) => _this.year = v,
    'androidx.compose.material3.internal.month_$external_prop_setter' : (_this, v) => _this.month = v,
    'androidx.compose.material3.internal.day_$external_prop_setter' : (_this, v) => _this.day = v,
    'androidx.compose.material3.internal.hour_$external_prop_setter' : (_this, v) => _this.hour = v,
    'androidx.compose.material3.internal.minute_$external_prop_setter' : (_this, v) => _this.minute = v,
    'androidx.compose.material3.internal.second_$external_prop_setter' : (_this, v) => _this.second = v,
    'androidx.compose.material3.internal.Date_$external_class_instanceof' : (x) => x instanceof Date,
    'androidx.compose.material3.internal.Date_$external_class_get' : () => Date,
    'androidx.navigation.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.navigation.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.navigation.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'io.github.alexzhirkevich.compottie.internal.blob' : (code) => new Blob([code], { type: 'application/javascript' }),
    'io.github.alexzhirkevich.compottie.internal.id_$external_prop_getter' : (_this) => _this.id,
    'io.github.alexzhirkevich.compottie.internal.kind_$external_prop_getter' : (_this) => _this.kind,
    'io.github.alexzhirkevich.compottie.internal.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'io.github.alexzhirkevich.compottie.internal.id_$external_prop_getter_1' : (_this) => _this.id,
    'io.github.alexzhirkevich.compottie.internal.message_$external_prop_getter' : (_this) => _this.message,
    'io.github.alexzhirkevich.compottie.internal.platform.DecodeImageRequest' : (id, buffer, width, height) => ({ id: id, data: buffer, w: width, h: height }),
    'io.github.alexzhirkevich.compottie.internal.platform.getSkikoMemory' : (skikoWasm) => skikoWasm.wasmExports.memory.buffer,
    'io.github.alexzhirkevich.compottie.currentTimeDouble' : () => Date.now(),
    'io.github.alexzhirkevich.compottie.DecompressionRequest' : (id, bytes) => ({ id: id, bytes: bytes }),
    'cc.bcc.createWorker' : () => new Worker(new URL("sqlite-web-worker/worker.js", import.meta.url)),
    'cc.bcc.component.openFilePickerJs' : (accept, multiple, callback) => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = accept;
        input.multiple = multiple;
        input.onchange = () => {
            const files = Array.from(input.files);
            if (files.length === 0) {
                callback(null);
                return;
            }
            const results = [];
            let loaded = 0;
            files.forEach((file, index) => {
                const reader = new FileReader();
                reader.onload = () => {
                    results[index] = new Uint8Array(reader.result);
                    loaded++;
                    if (loaded === files.length) {
                        callback(results);
                    }
                };
                reader.onerror = () => {
                    results[index] = null;
                    loaded++;
                    if (loaded === files.length) {
                        callback(results);
                    }
                };
                reader.readAsArrayBuffer(file);
            });
        };
        // キャンセル検出: focusが戻ってもファイルが選択されなかった場合
        input.oncancel = () => {
            callback(null);
        };
        input.click();
    },
    'cc.bcc.component.__convertKotlinClosureToJsClosure_((Js?)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Unit)'](f, p0)),
    'cc.bcc.component.jsArrayLength' : (arr) => arr.length,
    'cc.bcc.component.jsArrayGet' : (arr, i) => arr[i],
    'cc.bcc.component.uint8ArrayLength' : (arr) => arr.length,
    'cc.bcc.component.uint8ArrayGet' : (arr, i) => arr[i],
    'cc.bcc.component.common.isCoarsePointerNow' : () => !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches),
    'cc.bcc.infrastructure.jsAnalyticsLogEvent' : (name, paramsJson) => {
            try {
                globalThis.bccAnalytics?.logEvent(name, paramsJson);
            } catch (_) {}
        },
    'cc.bcc.infrastructure.jsAnalyticsSetCollectionEnabled' : (value) => {
            try {
                globalThis.bccAnalytics?.setCollectionEnabled(value);
            } catch (_) {}
        },
    'cc.bcc.infrastructure.jsAnalyticsSetUserProperty' : (name, value) => {
            try {
                globalThis.bccAnalytics?.setUserProperty(name, value);
            } catch (_) {}
        },
    'cc.bcc.infrastructure.jsAnalyticsSetUserId' : (userId) => {
            try {
                globalThis.bccAnalytics?.setUserId(userId.length > 0 ? userId : null);
            } catch (_) {}
        },
    'cc.bcc.infrastructure.bumpRoomCountJs' : () => {
            if (typeof globalThis.__bccRoomCount === 'number') {
                globalThis.__bccRoomCount = (globalThis.__bccRoomCount | 0) + 1;
            }
        },
    'cc.bcc.infrastructure.navigatorUserAgent' : () => navigator.userAgent,
    'cc.bcc.infrastructure.ensureHapticSwitch' : () => {
            if (typeof document === 'undefined') return;
            if (document.getElementById('bcc-web-haptic-label')) return;
            const label = document.createElement('label');
            label.id = 'bcc-web-haptic-label';
            label.setAttribute('for', 'bcc-web-haptic-switch');
            label.setAttribute('aria-hidden', 'true');
            label.style.display = 'none';
            const input = document.createElement('input');
            input.type = 'checkbox';
            input.setAttribute('switch', '');
            input.id = 'bcc-web-haptic-switch';
            input.tabIndex = -1;
            input.style.all = 'initial';
            input.style.appearance = 'auto';
            input.style.display = 'none';
            label.appendChild(input);
            document.body.appendChild(label);
        },
    'cc.bcc.infrastructure.hasVibrateApi' : () => typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function',
    'cc.bcc.infrastructure.vibratePattern' : (csv) => {
            try {
                navigator.vibrate(csv.split(',').map(Number));
            } catch (_) {}
        },
    'cc.bcc.infrastructure.clickHapticSwitch' : () => {
            const el = document.getElementById('bcc-web-haptic-label');
            if (el) el.click();
        },
    'cc.bcc.infrastructure.scheduleHapticClick' : (delayMs) => {
            setTimeout(() => {
                const el = document.getElementById('bcc-web-haptic-label');
                if (el) el.click();
            }, delayMs);
        },
    'cc.bcc.infrastructure.createUint8Array' : (size) => new Uint8Array(size),
    'cc.bcc.infrastructure.uint8ArraySet' : (arr, i, v) => { arr[i] = v; },
    'cc.bcc.infrastructure.writeImageToClipboardJs' : (pngBytes, resolve, reject) => {
        const blob = new Blob([pngBytes], {type: 'image/png'});
        const item = new ClipboardItem({'image/png': blob});
        navigator.clipboard.write([item]).then(() => {
            resolve();
        }).catch(err => {
            reject(err.message || 'Clipboard write failed');
        });
    },
    'cc.bcc.infrastructure.readImageFromClipboardJs' : (resolve) => {
        navigator.clipboard.read().then(items => {
            for (const item of items) {
                for (const type of item.types) {
                    if (type.startsWith('image/')) {
                        item.getType(type).then(blob => {
                            blob.arrayBuffer().then(buffer => {
                                resolve(new Uint8Array(buffer));
                            }).catch(() => resolve(null));
                        }).catch(() => resolve(null));
                        return;
                    }
                }
            }
            resolve(null);
        }).catch(() => {
            resolve(null);
        });
    },
    'cc.bcc.infrastructure.uint8ArrayLength' : (arr) => arr.length,
    'cc.bcc.infrastructure.uint8ArrayGet' : (arr, i) => arr[i],
    'cc.bcc.infrastructure.readTextFromClipboardJs' : (resolve) => {
        if (!navigator.clipboard || !navigator.clipboard.readText) {
            resolve(null);
            return;
        }
        navigator.clipboard.readText().then(text => {
            resolve(text || null);
        }).catch(() => {
            resolve(null);
        });
    },
    'cc.bcc.infrastructure.isWasmDevHostJs' : () => {
            try {
                const h = (typeof location !== 'undefined' && location.hostname) || '';
                return h === 'localhost' || h === '127.0.0.1' || h.endsWith('.ts.net');
            } catch (_) { return false; }
        },
    'cc.bcc.infrastructure.detectMobileBrowserOsJs' : () => {
            try {
                const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
                if (/iPad|iPhone|iPod/.test(ua)) return 'ios';
                if (/Macintosh/.test(ua) && typeof navigator !== 'undefined' &&
                    typeof navigator.maxTouchPoints === 'number' && navigator.maxTouchPoints > 1) {
                    return 'ios';
                }
                if (/Android/.test(ua)) return 'android';
            } catch (_) {}
            return '';
        },
    'cc.bcc.infrastructure.isPwaJs' : () => {
            try {
                if (typeof window !== 'undefined' && window.matchMedia &&
                    window.matchMedia('(display-mode: standalone)').matches) return true;
                if (typeof navigator !== 'undefined' && navigator.standalone === true) return true;
            } catch (_) {}
            return false;
        },
    'cc.bcc.infrastructure.vibrateJs' : () => { if (navigator && navigator.vibrate) { try { navigator.vibrate(20); } catch (e) {} } },
    'cc.bcc.infrastructure.requestWakeLockJs' : () => {
        if (!navigator.wakeLock) return null;
        let sentinel = null;
        navigator.wakeLock.request('screen').then(s => { sentinel = s; }).catch(() => {});
        return { release: () => { if (sentinel) sentinel.release(); } };
    },
    'cc.bcc.infrastructure.releaseWakeLockJs' : (lock) => { if (lock && lock.release) lock.release(); },
    'cc.bcc.infrastructure.formatNumberJs' : (n) => new Intl.NumberFormat().format(Number(n)),
    'cc.bcc.infrastructure.createUint8Array_1' : (size) => new Uint8Array(size),
    'cc.bcc.infrastructure.uint8ArraySet_1' : (arr, i, v) => { arr[i] = v; },
    'cc.bcc.infrastructure.downloadBlobJs' : (pngBytes, filename) => {
        const blob = new Blob([pngBytes], {type: 'image/png'});
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    },
    'cc.bcc.infrastructure.audio.createAudioContext' : (sampleRate) => new AudioContext({sampleRate: sampleRate}),
    'cc.bcc.infrastructure.audio.startRecordingJs' : (ctx, frameSize, callback) => {
        let accumulated = new Float32Array(0);
        navigator.mediaDevices.getUserMedia({audio: {
            sampleRate: ctx.sampleRate,
            channelCount: 1,
            echoCancellation: true,
            noiseSuppression: true,
            autoGainControl: true
        }}).then(stream => {
            const source = ctx.createMediaStreamSource(stream);
            const processor = ctx.createScriptProcessor(1024, 1, 1);
            processor.onaudioprocess = (e) => {
                const input = e.inputBuffer.getChannelData(0);
                const newAcc = new Float32Array(accumulated.length + input.length);
                newAcc.set(accumulated);
                newAcc.set(input, accumulated.length);
                accumulated = newAcc;
                while (accumulated.length >= frameSize) {
                    const int16 = new Int16Array(frameSize);
                    for (let i = 0; i < frameSize; i++) {
                        const s = Math.max(-1, Math.min(1, accumulated[i]));
                        int16[i] = s < 0 ? s * 0x8000 : s * 0x7FFF;
                    }
                    accumulated = accumulated.slice(frameSize);
                    callback(int16);
                }
            };
            source.connect(processor);
            processor.connect(ctx.destination);
            ctx._bccStream = stream;
            ctx._bccSource = source;
            ctx._bccProcessor = processor;
        }).catch(err => {
            console.error('getUserMedia failed:', err);
        });
    },
    'cc.bcc.infrastructure.audio.int16ArrayLength' : (arr) => arr.length,
    'cc.bcc.infrastructure.audio.int16ArrayGet' : (arr, i) => arr[i],
    'cc.bcc.infrastructure.audio.stopRecordingJs' : (ctx) => {
        if (ctx._bccProcessor) {
            ctx._bccProcessor.disconnect();
            ctx._bccProcessor.onaudioprocess = null;
            ctx._bccProcessor = null;
        }
        if (ctx._bccSource) {
            ctx._bccSource.disconnect();
            ctx._bccSource = null;
        }
        if (ctx._bccStream) {
            ctx._bccStream.getTracks().forEach(t => t.stop());
            ctx._bccStream = null;
        }
    },
    'cc.bcc.infrastructure.audio.createInt16Array' : (size) => new Int16Array(size),
    'cc.bcc.infrastructure.audio.int16ArraySet' : (arr, i, v) => { arr[i] = v; },
    'cc.bcc.infrastructure.audio.playBufferJs' : (ctx, pcmInt16, nextTime) => {
        const len = pcmInt16.length;
        const buffer = ctx.createBuffer(1, len, ctx.sampleRate);
        const channel = buffer.getChannelData(0);
        for (let i = 0; i < len; i++) {
            channel[i] = pcmInt16[i] / 32768.0;
        }
        const source = ctx.createBufferSource();
        source.buffer = buffer;
        source.connect(ctx.destination);
        const startTime = Math.max(nextTime, ctx.currentTime);
        source.start(startTime);
        return startTime + buffer.duration;
    },
    'cc.bcc.infrastructure.audio.resumeAudioContext' : (ctx) => ctx.resume(),
    'cc.bcc.infrastructure.audio.suspendAudioContext' : (ctx) => ctx.suspend(),
    'cc.bcc.infrastructure.audio.queryMicPermissionJs' : (resolve) => {
        navigator.permissions.query({name: 'microphone'}).then(result => {
            resolve(result.state);
        }).catch(() => {
            resolve('prompt');
        });
    },
    'cc.bcc.infrastructure.audio.requestMicPermissionJs' : (resolve) => {
        navigator.mediaDevices.getUserMedia({audio: true}).then(stream => {
            stream.getTracks().forEach(t => t.stop());
            resolve('granted');
        }).catch(err => {
            if (err.name === 'NotAllowedError') {
                resolve('denied');
            } else {
                resolve('denied');
            }
        });
    },
    'cc.bcc.infrastructure.audio.writeShorts' : (heap, ptr, shorts) => { for(let i=0;i<shorts.length;i++) heap[(ptr>>1)+i] = shorts[i]; },
    'cc.bcc.infrastructure.audio.readBytes' : (heap, ptr, len) => { const arr = new Int8Array(len); for(let i=0;i<len;i++) arr[i] = heap[ptr+i]; return arr; },
    'cc.bcc.infrastructure.audio.writeBytes' : (bytes, heap, ptr) => { for(let i=0;i<bytes.length;i++) heap[ptr+i] = bytes[i]; },
    'cc.bcc.infrastructure.audio.readShorts' : (heap, ptr, len) => { const arr = new Int16Array(len); for(let i=0;i<len;i++) arr[i] = heap[(ptr>>1)+i]; return arr; },
    'cc.bcc.infrastructure.audio.loadOpusModule' : () => globalThis.createOpusModule(),
    'cc.bcc.infrastructure.audio.thenJs' : (promise, resolve) => promise.then(v => resolve(v)),
    'cc.bcc.infrastructure.audio._opus_encoder_create_$external_fun' : (_this, p0, p1, p2, p3) => _this._opus_encoder_create(p0, p1, p2, p3),
    'cc.bcc.infrastructure.audio._opus_encoder_destroy_$external_fun' : (_this, p0) => _this._opus_encoder_destroy(p0),
    'cc.bcc.infrastructure.audio._opus_encode_$external_fun' : (_this, p0, p1, p2, p3, p4) => _this._opus_encode(p0, p1, p2, p3, p4),
    'cc.bcc.infrastructure.audio._opus_encoder_ctl_$external_fun' : (_this, p0, p1, p2) => _this._opus_encoder_ctl(p0, p1, p2),
    'cc.bcc.infrastructure.audio._opus_decoder_create_$external_fun' : (_this, p0, p1, p2) => _this._opus_decoder_create(p0, p1, p2),
    'cc.bcc.infrastructure.audio._opus_decoder_destroy_$external_fun' : (_this, p0) => _this._opus_decoder_destroy(p0),
    'cc.bcc.infrastructure.audio._opus_decode_$external_fun' : (_this, p0, p1, p2, p3, p4, p5) => _this._opus_decode(p0, p1, p2, p3, p4, p5),
    'cc.bcc.infrastructure.audio._malloc_$external_fun' : (_this, p0) => _this._malloc(p0),
    'cc.bcc.infrastructure.audio._free_$external_fun' : (_this, p0) => _this._free(p0),
    'cc.bcc.infrastructure.audio.heapU8_$external_prop_getter' : (_this) => _this.HEAPU8,
    'cc.bcc.infrastructure.audio.heap16_$external_prop_getter' : (_this) => _this.HEAP16,
    'cc.bcc.infrastructure.audio.createFloat32Array' : (size) => new Float32Array(size),
    'cc.bcc.infrastructure.audio.float32ArraySet' : (arr, i, v) => { arr[i] = v; },
    'cc.bcc.infrastructure.audio.writeFloats' : (heap, ptr, floats) => { for(let i=0;i<floats.length;i++) heap[(ptr>>2)+i] = floats[i]; },
    'cc.bcc.infrastructure.audio.readFloats' : (heap, ptr, len) => { const arr = new Float32Array(len); for(let i=0;i<len;i++) arr[i] = heap[(ptr>>2)+i]; return arr; },
    'cc.bcc.infrastructure.audio.float32ArrayGet' : (arr, i) => arr[i],
    'cc.bcc.infrastructure.audio.loadPitchShifterModule' : () => globalThis.createPitchShifterModule(),
    'cc.bcc.infrastructure.audio.thenJs_1' : (promise, resolve) => promise.then(v => resolve(v)),
    'cc.bcc.infrastructure.audio._pitch_shifter_create_$external_fun' : (_this, p0, p1) => _this._pitch_shifter_create(p0, p1),
    'cc.bcc.infrastructure.audio._pitch_shifter_process_$external_fun' : (_this, p0, p1, p2, p3, p4) => _this._pitch_shifter_process(p0, p1, p2, p3, p4),
    'cc.bcc.infrastructure.audio._pitch_shifter_flush_$external_fun' : (_this, p0, p1, p2) => _this._pitch_shifter_flush(p0, p1, p2),
    'cc.bcc.infrastructure.audio._pitch_shifter_get_output_size_$external_fun' : (_this, p0) => _this._pitch_shifter_get_output_size(p0),
    'cc.bcc.infrastructure.audio._pitch_shifter_get_output_$external_fun' : (_this, p0, p1, p2) => _this._pitch_shifter_get_output(p0, p1, p2),
    'cc.bcc.infrastructure.audio._pitch_shifter_reset_$external_fun' : (_this, p0) => _this._pitch_shifter_reset(p0),
    'cc.bcc.infrastructure.audio._malloc_$external_fun_1' : (_this, p0) => _this._malloc(p0),
    'cc.bcc.infrastructure.audio._free_$external_fun_1' : (_this, p0) => _this._free(p0),
    'cc.bcc.infrastructure.audio.heapF32_$external_prop_getter' : (_this) => _this.HEAPF32,
    'cc.bcc.infrastructure.auth.relay.decodeUriComponentJs' : (s) => decodeURIComponent(s),
    'cc.bcc.infrastructure.auth.relay.encodeUriComponentJs' : (s) => encodeURIComponent(s),
    'cc.bcc.infrastructure.auth.relay.closePopupJs' : (w) => { try { w.close(); } catch (e) {} },
    'cc.bcc.infrastructure.auth.relay.openBlankPopup' : () => { try { return window.open('about:blank', '_blank') ?? null; } catch (e) { return null; } },
    'cc.bcc.infrastructure.auth.relay.navigatePopup' : (w, url) => { try { w.location.href = url; return true; } catch (e) { return false; } },
    'cc.bcc.infrastructure.auth.relay.ssSet' : (k, v) => { sessionStorage.setItem(k, v); },
    'cc.bcc.infrastructure.auth.relay.ssGet' : (k) => sessionStorage.getItem(k),
    'cc.bcc.infrastructure.auth.relay.ssRemove' : (k) => { sessionStorage.removeItem(k); },
    'cc.bcc.infrastructure.auth.relay.newUint8Array' : (size) => new Uint8Array(size),
    'cc.bcc.infrastructure.auth.relay.uint8Set' : (arr, i, v) => { arr[i] = v; },
    'cc.bcc.infrastructure.auth.relay.cryptoSha256' : (data) => crypto.subtle.digest('SHA-256', data.buffer),
    'cc.bcc.infrastructure.auth.relay.thenPromise' : (promise, resolve) => promise.then(v => resolve(v)),
    'cc.bcc.infrastructure.auth.relay.toUint8Array' : (buffer) => new Uint8Array(buffer),
    'cc.bcc.infrastructure.auth.relay.uint8Length' : (arr) => arr.length,
    'cc.bcc.infrastructure.auth.relay.uint8Get' : (arr, i) => arr[i],
    'cc.bcc.infrastructure.datetime.formatDateJs' : (epochMs) => {
        const d = new Date(epochMs);
        return new Intl.DateTimeFormat(undefined, {
            year: 'numeric', month: '2-digit', day: '2-digit'
        }).format(d);
    },
    'cc.bcc.infrastructure.datetime.formatDateTimeJs' : (epochMs) => {
        const d = new Date(epochMs);
        return new Intl.DateTimeFormat(undefined, {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit'
        }).format(d);
    },
    'cc.bcc.infrastructure.notification.hasNotificationApi' : () => typeof Notification !== 'undefined',
    'cc.bcc.infrastructure.notification.hasBccFcmBridge' : () => typeof window.bccFcm === 'object' && window.bccFcm !== null && typeof window.bccFcm.getToken === 'function',
    'cc.bcc.infrastructure.notification.notificationPermission' : () => (typeof Notification !== 'undefined') ? Notification.permission : 'denied',
    'cc.bcc.infrastructure.notification.bccFcmGetTokenBridge' : (onResolve, onReject) => {
            try {
                const p = window.bccFcm.getToken();
                p.then(
                  (v) => onResolve((typeof v === 'string' && v.length > 0) ? v : null),
                  (e) => onReject(e ? String(e) : 'unknown')
                );
            } catch (e) {
                onReject(e ? String(e) : 'unknown');
            }
        },
    'cc.bcc.infrastructure.notification.__convertKotlinClosureToJsClosure_((String?)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((String?)->Unit)'](f, p0)),
    'cc.bcc.infrastructure.notification.__convertKotlinClosureToJsClosure_((String)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((String)->Unit)'](f, p0)),
    'cc.bcc.infrastructure.notification.hasNotificationApi_1' : () => typeof Notification !== 'undefined',
    'cc.bcc.infrastructure.notification.notificationPermission_1' : () => (typeof Notification !== 'undefined') ? Notification.permission : 'denied',
    'cc.bcc.infrastructure.notification.notificationRequestPermissionBridge' : (cb) => {
            if (typeof Notification === 'undefined') { cb('denied'); return; }
            try {
                const p = Notification.requestPermission();
                if (p && typeof p.then === 'function') {
                    p.then((v) => cb(v || Notification.permission || 'denied'),
                           () => cb(Notification.permission || 'denied'));
                } else {
                    cb(Notification.permission || 'denied');
                }
            } catch (_) { cb(Notification.permission || 'denied'); }
        },
    'cc.bcc.safe.readKeyboardHeightPx' : () => {
            const vv = window.visualViewport;
            if (!vv) return 0;
            return Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
        },
    'cc.bcc.safe.bccInstallVisualViewportRefresh' : (callback) => {
            const vv = window.visualViewport;
            if (!vv) return;
            window.__bccImeVvHandler = callback;
            vv.addEventListener('resize', callback);
            vv.addEventListener('scroll', callback);
        },
    'cc.bcc.safe.bccInstallFocusPolling' : (refresh) => {
            const TIMES = [0, 50, 100, 200, 400, 800, 1200];
            let pendingTimers = [];
            const clear = () => {
                pendingTimers.forEach(clearTimeout);
                pendingTimers = [];
            };
            const schedule = () => {
                clear();
                TIMES.forEach((d) => {
                    pendingTimers.push(setTimeout(refresh, d));
                });
            };
            const onFocusIn = (e) => {
                const target = e.target;
                if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA')) {
                    try {
                        target.scrollIntoView({ block: 'end', inline: 'nearest' });
                    } catch (_) {}
                }
                schedule();
            };
            const onFocusOut = () => schedule();
            window.__bccImeFocusIn = onFocusIn;
            window.__bccImeFocusOut = onFocusOut;
            window.__bccImeClearTimers = clear;
            // capture: true で shadow DOM 越しの focus も拾う
            document.addEventListener('focusin', onFocusIn, true);
            document.addEventListener('focusout', onFocusOut, true);
        },
    'cc.bcc.safe.bccUninstallVisualViewportRefresh' : () => {
            const vv = window.visualViewport;
            const handler = window.__bccImeVvHandler;
            if (vv && handler) {
                vv.removeEventListener('resize', handler);
                vv.removeEventListener('scroll', handler);
            }
            window.__bccImeVvHandler = null;
        },
    'cc.bcc.safe.bccUninstallFocusPolling' : () => {
            if (window.__bccImeFocusIn) {
                document.removeEventListener('focusin', window.__bccImeFocusIn, true);
                document.removeEventListener('focusout', window.__bccImeFocusOut, true);
            }
            if (window.__bccImeClearTimers) window.__bccImeClearTimers();
            window.__bccImeFocusIn = null;
            window.__bccImeFocusOut = null;
            window.__bccImeClearTimers = null;
        },
    'cc.bcc.safe.readSafeAreaLeftPx' : () => parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--bcc-safe-left')) || 0,
    'cc.bcc.safe.readSafeAreaTopPx' : () => parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--bcc-safe-top')) || 0,
    'cc.bcc.safe.readSafeAreaRightPx' : () => parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--bcc-safe-right')) || 0,
    'cc.bcc.safe.readSafeAreaBottomPx' : () => parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--bcc-safe-bottom')) || 0,
    'cc.bcc.sqlite.web.fileName_$external_prop_setter' : (_this, v) => _this.fileName = v,
    'cc.bcc.sqlite.web.databaseId_$external_prop_getter' : (_this) => _this.databaseId,
    'cc.bcc.sqlite.web.databaseId_$external_prop_setter' : (_this, v) => _this.databaseId = v,
    'cc.bcc.sqlite.web.sql_$external_prop_setter' : (_this, v) => _this.sql = v,
    'cc.bcc.sqlite.web.statementId_$external_prop_getter' : (_this) => _this.statementId,
    'cc.bcc.sqlite.web.parameterCount_$external_prop_getter' : (_this) => _this.parameterCount,
    'cc.bcc.sqlite.web.columnNames_$external_prop_getter' : (_this) => _this.columnNames,
    'cc.bcc.sqlite.web.statementId_$external_prop_setter' : (_this, v) => _this.statementId = v,
    'cc.bcc.sqlite.web.bindings_$external_prop_setter' : (_this, v) => _this.bindings = v,
    'cc.bcc.sqlite.web.rows_$external_prop_getter' : (_this) => _this.rows,
    'cc.bcc.sqlite.web.columnTypes_$external_prop_getter' : (_this) => _this.columnTypes,
    'cc.bcc.sqlite.web.statementId_$external_prop_setter_1' : (_this, v) => _this.statementId = v,
    'cc.bcc.sqlite.web.databaseId_$external_prop_setter_1' : (_this, v) => _this.databaseId = v,
    'cc.bcc.sqlite.web.cmd_$external_prop_setter' : (_this, v) => _this.cmd = v,
    'cc.bcc.sqlite.web.jsTypeofString' : (value) => typeof value === 'string',
    'cc.bcc.sqlite.web.jsTypeofNumber' : (value) => typeof value === 'number',
    'cc.bcc.sqlite.web.jsIsInteger' : (value) => Number.isInteger(value),
    'cc.bcc.sqlite.web.jsTypeofBigInt' : (value) => typeof value === 'bigint',
    'cc.bcc.sqlite.web.jsIsUint8Array' : (value) => value instanceof Uint8Array,
    'cc.bcc.sqlite.web.util.initExternal' : () => ({}),
    'cc.bcc.sqlite.web.worker.id_$external_prop_getter' : (_this) => _this.id,
    'cc.bcc.sqlite.web.worker.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'cc.bcc.sqlite.web.worker.data_$external_prop_getter' : (_this) => _this.data,
    'cc.bcc.sqlite.web.worker.data_$external_prop_setter' : (_this, v) => _this.data = v,
    'cc.bcc.sqlite.web.worker.error_$external_prop_getter' : (_this) => _this.error,
    'cc.bcc.sqlite.web.worker.error_$external_prop_setter' : (_this, v) => _this.error = v,
    'full.readInitialInstalled' : () => {
            const v = globalThis.__bccWasmFullPwaInstalled__;
            return v === true;
        },
    'full.invokePromptInstall' : () => {
            const fn = globalThis.__bccWasmFullPromptInstall__;
            if (typeof fn === 'function') {
                try { fn(); } catch (_) {}
            }
        },
    'full.readInitialLocale' : () => {
            const v = globalThis.__bccWasmFullLocale__;
            return (typeof v === 'string') ? v : '';
        },
    'full.readInitialRegion' : () => {
            const v = globalThis.__bccWasmFullRegion__;
            return (typeof v === 'string') ? v : '';
        },
    'full.readEventLang' : (e) => {
            const v = e && e.detail && e.detail.lang;
            return (typeof v === 'string') ? v : '';
        },
    'full.readEventRegion' : (e) => {
            const v = e && e.detail && e.detail.region;
            return (typeof v === 'string') ? v : '';
        },
    'full.readEventDataString' : (e, key) => {
            try {
                const d = e && e.detail && e.detail.data;
                if (!d) return '';
                const v = d[key];
                return (typeof v === 'string') ? v : '';
            } catch (_) {
                return '';
            }
        },
    'full.readEventLink' : (e) => {
            const v = e && e.detail && e.detail.link;
            return (typeof v === 'string') ? v : '';
        },
    'full.readUrlCode' : () => {
            try {
                const params = new URLSearchParams(window.location.search);
                return params.get('code') || '';
            } catch (_) {
                return '';
            }
        },
    'full.readCookieRaw' : (name) => {
            try {
                const all = document.cookie || '';
                const target = name + '=';
                for (const part of all.split('; ')) {
                    if (part.indexOf(target) === 0) {
                        return decodeURIComponent(part.substring(target.length));
                    }
                }
                return '';
            } catch (_) {
                return '';
            }
        },
    'full.readLocalStorageRaw' : (key) => {
            try {
                return window.localStorage.getItem(key) || '';
            } catch (_) {
                return '';
            }
        },
    'readResourceBasePath' : () => {
            const v = globalThis.__bccWasmFullResourceBase__;
            return (typeof v === 'string' && v.length > 0) ? v : '/app';
        },
    'readInitialEnv' : () => {
            const v = globalThis.__bccWasmFullEnv__;
            return (typeof v === 'string' && v.length > 0) ? v : 'production';
        },
    'bccLoadingSetProgress' : (p) => {
            try {
                if (typeof window !== 'undefined' && window.__bccLoading) {
                    window.__bccLoading.setProgress(p);
                }
            } catch (_) {}
        },
    'bccLoadingDone' : () => {
            try {
                if (typeof window !== 'undefined' && window.__bccLoading) {
                    window.__bccLoading.done();
                }
            } catch (_) {}
        },
    'readInitialFullUrl' : () => {
            try {
                var loc = window.location;
                var path = '';
                try { path = decodeURIComponent(loc.pathname || ''); }
                catch (_) { path = loc.pathname || ''; }
                return (loc.origin || '') + path + (loc.search || '') + (loc.hash || '');
            } catch (_) {
                return '';
            }
        },
    'readInitialNotificationLink' : () => {
            try {
                const params = new URLSearchParams(window.location.search || '');
                const v = params.get('notification_link');
                if (typeof v !== 'string' || v.length === 0) return '';
                try {
                    params.delete('notification_link');
                    const qs = params.toString();
                    const newUrl = window.location.pathname +
                        (qs ? '?' + qs : '') +
                        (window.location.hash || '');
                    window.history.replaceState({}, '', newUrl);
                } catch (_) {}
                return v;
            } catch (_) {
                return '';
            }
        }
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    